import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { TableSections } from "./components/TableSections";
import { CatalogSection } from "@/shared/models/CatalogSection";
import { getCatalogSections } from "@/shared/repositories/CatalogSectionRepository";

type useCatalogSectionsProps = {
	onError?: (error: Error) => void;
};

export const useCatalogSections = ({ onError }: useCatalogSectionsProps) => {
	return useQuery<CatalogSection[], Error>({
		queryKey: ["catalogSections"],
		queryFn: () => getCatalogSections(),
		onError: onError,
	});
};

export const CatalogSectionsPage = () => {
	return (
		<>
			<HelmetDexteel title="Sections - Configurations" />
			<TableSections />
		</>
	);
};
